import { APEX_BASE_URL, getApexUrl } from 'alakai-aloha-shared';

export function getConfiguredPublicBaseUrl() {
  return process.env.REACT_APP_PUBLIC_BASE_URL || APEX_BASE_URL;
}

export function getRuntimePublicBaseUrl() {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }

  return getConfiguredPublicBaseUrl();
}

export function buildApexCanonicalUrl(path = '') {
  return getApexUrl(path);
}

export function buildAbsoluteUrl(baseUrl, path = '') {
  const normalizedBase = String(baseUrl || '').replace(/\/+$/, '');
  const normalizedPath = String(path || '');

  if (!normalizedPath) {
    return normalizedBase;
  }

  if (/^https?:\/\//i.test(normalizedPath)) {
    return normalizedPath;
  }

  return `${normalizedBase}${normalizedPath.startsWith('/') ? '' : '/'}${normalizedPath}`;
}

export function buildRuntimeCanonicalUrl(path = '') {
  return buildAbsoluteUrl(getRuntimePublicBaseUrl(), path);
}
